import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import SectionHeader from "../common/SectionHeader";
import AdRequestList from "./AdRequestList";
import CreateAdRequestChoiceModal from "./Modals/CreateAdRequestChoiceModal";
import UploadExcelModal from "./Modals/UploadExcelModal";
import SingleAdRequestModal from "./Modals/SingleAdRequestModal";
import AdRequestSheetModal from "./Modals/AdRequestSheetModal";
import { Button } from "../ui/button";
import usePermissions from "../../hooks/usePermissions";
import { PERMISSION_CODES } from "../../utils/constants/permissions";

const AdRequestSection = ({ view }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [choiceModalOpen, setChoiceModalOpen] = useState(false);
  const [uploadExcelOpen, setUploadExcelOpen] = useState(false);
  const [singleOpen, setSingleOpen] = useState(false);
  const [sheetImportOpen, setSheetImportOpen] = useState(false);
  const { hasPermission } = usePermissions();

  useEffect(() => {
    if (searchParams.get("open") === "create") {
      setChoiceModalOpen(true);
      searchParams.delete("open");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <section className="p-4 md:p-6">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <SectionHeader
          title={view === "assigned" ? "Assigned ad requests" : "Ad Request"}
        />
        {view !== "assigned" &&
          hasPermission(PERMISSION_CODES.AD_REQUEST_CREATE) && (
            <Button onClick={() => setChoiceModalOpen(true)}>
              Create ad request
            </Button>
          )}
      </div>
      <AdRequestList view={view} />
      <CreateAdRequestChoiceModal
        open={choiceModalOpen}
        onClose={() => setChoiceModalOpen(false)}
        onUploadExcel={() => setUploadExcelOpen(true)}
        onSheetImport={() => setSheetImportOpen(true)}
        onCreateSingle={() => setSingleOpen(true)}
      />
      <UploadExcelModal
        open={uploadExcelOpen}
        onClose={() => setUploadExcelOpen(false)}
      />
      <AdRequestSheetModal
        open={sheetImportOpen}
        onClose={() => setSheetImportOpen(false)}
      />
      <SingleAdRequestModal
        open={singleOpen}
        onClose={() => setSingleOpen(false)}
      />
    </section>
  );
};

export default AdRequestSection;
